import React from "react";
import { Link } from "react-router-dom";
import { FiCalendar, FiTag, FiClock, FiArrowRight, FiStar } from "react-icons/fi";
import { getReadingTime } from "../../../utils/reading";
import { categoryColor } from "../../../utils/category";
import { cropCenter } from "../../../utils/image";
import "./FeaturedBlog.css";

const FeaturedBlog = ({ blog }) => {
  const accent = categoryColor(blog.category);

  return (
    <Link to={`/blog/${blog.slug}`} className="featured-blog-link">
      <div className="featured-blog">
        <div className="featured-image">
          <img src={blog.image} alt={blog.title} style={{ objectPosition: cropCenter(blog.imageCrop) }} />
          <span className="featured-flag">
            <FiStar /> Öne Çıkan
          </span>
        </div>
        <div className="featured-content">
          <div className="meta-info">
            <div className="meta-item">
              <FiCalendar />
              <span>{new Date(blog.date).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" })}</span>
            </div>
            <div className="divider" />
            <div className="meta-item" style={{ color: accent }}>
              <FiTag />
              <span>{blog.category}</span>
            </div>
            <div className="divider" />
            <div className="meta-item">
              <FiClock />
              <span>{getReadingTime(blog.content)}</span>
            </div>
          </div>
          <h2 title={blog.title}>{blog.title}</h2>
          {blog.summary && <p className="featured-summary">{blog.summary}</p>}
          <span className="featured-read-more">
            Devamını Oku <FiArrowRight />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default FeaturedBlog;
